import { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import AchievementsBanner from "@nualang/nualang-ui-components/dist/Misc/AchievementsBanner/AchievementsBanner";
import MedalCard from "@nualang/nualang-ui-components/dist/Misc/MedalCard/MedalCard";
import NualaMascot from "@nualang/nualang-ui-components/dist/Misc/NualaMascot/NualaMascot";
import trophyBg from "./TrophyBackground.svg";

const TOTAL_SLOTS = 8;

function MedalCategory({ medals }) {
  const slotCount = Math.max(TOTAL_SLOTS, medals.length);
  const slots = Array.from({ length: slotCount }, (_, i) => medals[i] || null);

  const [mascotState, setMascotState] = useState(() => ({
    slot: Math.floor(Math.random() * slotCount),
    angle: Math.round(Math.random() * 180) - 90,
    variant: Math.floor(Math.random() * 4),
    tick: 0,
  }));

  useEffect(() => {
    const interval = setInterval(() => {
      setMascotState(prev => ({
        slot: Math.floor(Math.random() * slotCount),
        angle: Math.round(Math.random() * 180) - 90,
        variant: Math.floor(Math.random() * 4),
        tick: prev.tick + 1,
      }));
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ mb: 5 }}>
      <Grid container spacing={3}>
        {slots.map((medal, index) => (
          <Grid
            key={index}
            size={{ xs: 6, sm: 6, md: 4, lg: 3 }}
            sx={{ paddingBottom: 5, display: "flex", flexDirection: "column" }}
          >
            <MedalCard
              medal={medal}
              mascot={index === mascotState.slot
                ? <NualaMascot key={`${mascotState.slot}-${mascotState.tick}`} angle={mascotState.angle} variant={mascotState.variant} />
                : null
              }
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default function AchievementsScreen({ categories = [] }) {
  const featured = categories[0];

  return (
    <Box sx={{ px: { xs: 2, sm: 3 }, py: { xs: 1, sm: 2 } }}>
      {featured && (
        <AchievementsBanner
          title={featured.title}
          description={featured.description}
          backgroundImage={trophyBg}
        />
      )}
      {categories.map((category) => (
        <MedalCategory
          key={category.title}
          medals={category.medals}
        />
      ))}
    </Box>
  );
}
